import React from 'react';
import { useReactToPrint } from 'react-to-print';
import { Btn } from '../../../AbstractElements';
import { Cancel, Print } from '../../../Constant';

const InvoiceFooter = ({ printParent }) => {
  const handlePrint = useReactToPrint({
    content: () => printParent.current,
  });

  return (
    <>
      <div className='text-center mt-3'>
        <Btn onClick={handlePrint} color='primary' className='me-2'>
          {Print}
        </Btn>
        <Btn color='secondary'>{Cancel}</Btn>
      </div>
    </>
  );
};

export default InvoiceFooter;
